export default {"src":"/_next/static/media/trainers.8a764d1c.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};